import React, { FunctionComponent } from "react";
import styled from "styled-components";

type Property = {
  language: string;
}

const StyledCodeBlock = styled.code`
  font-size: 1.2rem;
  border-radius: 4px;
`;

export const CodeBlock: FunctionComponent<Property> = (props) =>(
  <StyledCodeBlock className={props.language}>
    {props.children}
  </StyledCodeBlock>
)